export default "__VITE_ASSET__Ck9ir5nJ__"